/**
 * rb-byob-desk-coll-2up-v1 / rb-byob-mobile-coll-match-v1 — Yotpo stars + effect pills (desktop + mobile).
 */
(function () {
  var YOTPO_KEY = 'Ioh4q2i1hYPxfsXa70UJV30ezP7GCp6PGQluCzib';
  /* rb-byob-calm-relax-v1 — real product handles; Calm is relax, never sleep */
  var HANDLE_EFFECT = {
    'delta-9-gummy': 'euphoric',
    'd9-gummies': 'euphoric',
    'd9-gummy': 'euphoric',
    'd8-gummies': 'euphoric',
    'd9-drink-mix': 'euphoric',
    'delta-9-drink-mix': 'euphoric',
    'd8-disposable': 'euphoric',
    'd8-cartridge': 'euphoric',
    'delta-8-disposable': 'euphoric',
    'delta-8-cartridge': 'euphoric',
    'delta-8-gummy': 'euphoric',
    'd8-tincture': 'euphoric',
    'cbd-classic-tincture': 'wellness',
    'cbd-ultra-classic-tincture': 'wellness',
    'cbd-classic-gummies': 'wellness',
    'cbd-classic-softgels': 'wellness',
    'cbd-calm-gummies': 'relax',
    'cbd-cbn-cbg-calm-gummies': 'relax',
    'cbd-calm-softgels': 'relax',
    'cbd-pain-gummies': 'relieve',
    'cbd-pain-softgels': 'relieve',
    'cbd-pain-tincture': 'relieve',
    'cbd-ultra-pain-tincture': 'relieve',
    'cbd-sleep-gummies': 'sleep',
    'cbd-cbn-sleep-gummies': 'sleep',
    'cbd-sleep-tincture': 'sleep',
    'cbd-ultra-sleep-tincture': 'sleep',
    'cbd-sleep-softgels': 'sleep',
    'cbd-calm-tincture': 'relax',
    'cbd-ultra-calm-tincture': 'relax',
    'cbd-pet-tincture': 'pet',
    'cbd-pet-treats': 'pet'
  };
  var EFFECT_META = {
    relieve: { label: 'Relieve', color: '#A93737' },
    relax: { label: 'Relax', color: '#D36F3A' },
    sleep: { label: 'Sleep', color: '#326CB2' },
    euphoric: { label: 'Euphoric', color: '#8C56C5' },
    wellness: { label: 'Wellness', color: '#4DA457' },
    pet: { label: 'Pet', color: '#9A5D5D' },
    kratom: { label: 'Kratom', color: '#1B4A35' }
  };
  var cache = {};

  function cardTitle(item) {
    var el =
      item.querySelector('.gbbProductTitleOnly') ||
      item.querySelector('.gbbProductTitle') ||
      item.querySelector('.gbbProductItemTitle');
    return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function slug(title) {
    return String(title || '')
      .toLowerCase()
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function isKratomText(text) {
    var t = String(text || '').toLowerCase();
    return t.indexOf('kratom') !== -1 || t.indexOf('kava') !== -1;
  }

  function effectFromTitle(text) {
    var t = String(text || '').toLowerCase();
    if (!t) return '';
    if (t.indexOf('pet') !== -1) return 'pet';
    if (t.indexOf('calm') !== -1) return 'relax';
    if (t.indexOf('sleep') !== -1) return 'sleep';
    if (t.indexOf('pain') !== -1 || t.indexOf('relieve') !== -1) return 'relieve';
    if (t.indexOf('relax') !== -1) return 'relax';
    if (t.indexOf('d9') !== -1 || t.indexOf('d8') !== -1 || t.indexOf('delta') !== -1) return 'euphoric';
    if (t.indexOf('classic') !== -1 || t.indexOf('wellness') !== -1) return 'wellness';
    return '';
  }

  function effectFromProduct(p) {
    if (!p) return '';
    if (isKratomText(p.title) || isKratomText(p.handle) || isKratomText(p.vendor)) return 'kratom';
    if (HANDLE_EFFECT[p.handle]) return HANDLE_EFFECT[p.handle];
    var fromTitle = effectFromTitle(p.title);
    if (fromTitle) return fromTitle;
    var tags = Array.isArray(p.tags) ? p.tags.join(' ').toLowerCase() : '';
    var keys = ['pet', 'euphoric', 'wellness', 'relieve', 'relax', 'sleep'];
    for (var i = 0; i < keys.length; i += 1) {
      if (tags.indexOf(keys[i]) !== -1) return keys[i];
    }
    return '';
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('bad');
      return r.json();
    });
  }

  function resolveProduct(id, title) {
    var key = String(id || title);
    if (cache[key]) return cache[key];
    cache[key] = (function () {
      var handle = slug(title);
      var tries = [];
      if (handle) tries.push('/products/' + encodeURIComponent(handle) + '.js');
      if (title) {
        tries.push(
          '/search/suggest.json?q=' +
            encodeURIComponent(title) +
            '&resources[type]=product&resources[limit]=6'
        );
      }
      function next(i) {
        if (i >= tries.length) return Promise.resolve(null);
        return fetchJson(tries[i])
          .then(function (data) {
            if (data && data.id) return data;
            var products =
              data &&
              data.resources &&
              data.resources.results &&
              data.resources.results.products;
            if (products && products.length) {
              var match = products.filter(function (p) {
                return String(p.id) === String(id);
              })[0] || products[0];
              if (match && match.handle) {
                return fetchJson('/products/' + encodeURIComponent(match.handle) + '.js');
              }
              return match || null;
            }
            return next(i + 1);
          })
          .catch(function () {
            return next(i + 1);
          });
      }
      return next(0);
    })();
    return cache[key];
  }

  function ensureStars(item, product) {
    if (item.querySelector('.rb-product__meta-row')) return;
    var title =
      item.querySelector('.gbbProductTitleOnly') ||
      item.querySelector('.gbbProductTitle') ||
      item.querySelector('.gbbProductItemTitle');
    if (!title || !title.parentNode) return;
    var row = document.createElement('div');
    row.className = 'rb-product__meta-row';
    var stars = document.createElement('div');
    stars.className = 'rb-product__stars';
    var yotpo = document.createElement('div');
    yotpo.className = 'yotpo bottomLine';
    yotpo.setAttribute('data-appkey', YOTPO_KEY);
    yotpo.setAttribute('data-product-id', String(product.id));
    yotpo.setAttribute('data-name', product.title || '');
    yotpo.setAttribute('data-url', product.url || ('/products/' + product.handle));
    stars.appendChild(yotpo);
    row.appendChild(stars);
    title.parentNode.insertBefore(row, title.nextSibling);
  }

  function ensurePill(item, key) {
    if (!key || !EFFECT_META[key]) return;
    var meta = EFFECT_META[key];
    var existing = item.querySelector('.rb-product__effect-pill');
    if (existing) {
      if (existing.getAttribute('data-effect') !== key) {
        existing.setAttribute('data-effect', key);
        existing.style.setProperty('--rb-effect-color', meta.color);
        existing.textContent = meta.label;
      }
      return;
    }
    var action =
      item.querySelector('.gbbProductActionContainer') ||
      item.querySelector('.gbbProductItemPricesContainer') ||
      item.querySelector('.gbbProductPricesContainer');
    if (!action) return;
    action.classList.add('rb-product__price-row');
    var pill = document.createElement('span');
    pill.className = 'rb-product__effect-pill';
    pill.setAttribute('data-effect', key);
    pill.style.setProperty('--rb-effect-color', meta.color);
    pill.textContent = meta.label;
    action.appendChild(pill);
  }

  function applyQuickEffect(item, title) {
    var quickHandle = slug(title);
    var quickKratom = isKratomText(title) || isKratomText(quickHandle);
    var quickEffect = quickKratom
      ? 'kratom'
      : HANDLE_EFFECT[quickHandle] || effectFromTitle(title);
    item.classList.toggle('rb-product--kratom-effect', quickKratom);
    item.classList.toggle('rb-product--canna-effect', !quickKratom && !!quickEffect);
    if (quickEffect) {
      item.removeAttribute('data-rb-byob-nopill');
      ensurePill(item, quickEffect);
    } else {
      item.setAttribute('data-rb-byob-nopill', '1');
    }
    return quickEffect;
  }

  function decorate(item) {
    /* rb-byob-mob-pills-persist-v1 — only run when stars/pill were wiped (GBB re-render) */
    if (item.getAttribute('data-rb-byob-coll') === 'pending') return;

    var id = item.getAttribute('productid') || item.getAttribute('productId');
    var title = cardTitle(item);
    if (!id && !title) return;

    /* rb-byob-mob-sync-effect-v1 — paint pill + ring vars before async fetch (no green flash) */
    var hasPill = !!item.querySelector('.rb-product__effect-pill');
    if (!hasPill && item.getAttribute('data-rb-byob-nopill') !== '1') {
      applyQuickEffect(item, title);
      hasPill = !!item.querySelector('.rb-product__effect-pill');
    }

    var hasStars = !!item.querySelector('.rb-product__meta-row');
    if (hasStars && (hasPill || item.getAttribute('data-rb-byob-nopill') === '1')) {
      item.setAttribute('data-rb-byob-coll', '1');
      return;
    }

    item.setAttribute('data-rb-byob-coll', 'pending');
    resolveProduct(id, title)
      .then(function (product) {
        var p = product || { id: id, title: title, handle: slug(title), tags: [] };
        var kratom = isKratomText(p.title) || isKratomText(p.handle) || isKratomText(title);
        var effect = effectFromProduct(p) || (kratom ? 'kratom' : '');
        item.classList.toggle('rb-product--kratom-effect', kratom);
        item.classList.toggle('rb-product--canna-effect', !kratom && !!effect);
        var createdStars = !item.querySelector('.rb-product__meta-row');
        if (p.id) ensureStars(item, p);
        if (effect) {
          item.removeAttribute('data-rb-byob-nopill');
          ensurePill(item, effect);
        } else {
          item.setAttribute('data-rb-byob-nopill', '1');
        }
        item.setAttribute('data-rb-byob-coll', '1');
        if (createdStars && typeof window.rbHydrateProductStars === 'function') {
          window.rbHydrateProductStars();
        }
        scheduleByobHighlight();
      })
      .catch(function () {
        item.setAttribute('data-rb-byob-coll', '1');
        scheduleByobHighlight();
      });
  }

  /* rb-byob-mob-card-highlight-v1 — scroll highlight matches collection effect-pill ring */
  var highlightRaf = 0;
  var highlightBound = false;

  function isMobileHighlight() {
    return typeof window.rbIsTouchMobile === 'function'
      ? window.rbIsTouchMobile(999)
      : window.matchMedia('(max-width: 999px)').matches;
  }

  function syncByobCardHighlight() {
    var root = document.querySelector('#gbbBundle');
    if (!root) return;

    var cards = root.querySelectorAll('.gbbProductItem');
    if (!cards.length) return;

    if (!isMobileHighlight()) {
      cards.forEach(function (card) {
        card.classList.remove('is-carousel-active');
      });
      return;
    }

    var focusY = window.innerHeight * 0.42;
    var focusX = window.innerWidth * 0.5;
    var best = null;
    var bestScore = Infinity;

    cards.forEach(function (card) {
      if (
        !card.classList.contains('rb-product--canna-effect') &&
        !card.classList.contains('rb-product--kratom-effect')
      ) {
        return;
      }
      var rect = card.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) return;
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

      var visibleTop = Math.max(rect.top, 0);
      var visibleBottom = Math.min(rect.bottom, window.innerHeight);
      var visible = Math.max(0, visibleBottom - visibleTop);
      if (visible < Math.min(rect.height * 0.28, 80)) return;

      var cx = rect.left + rect.width * 0.5;
      var cy = rect.top + rect.height * 0.5;
      var score = Math.abs(cy - focusY) + Math.abs(cx - focusX) * 0.4 - visible * 0.12;
      if (score < bestScore) {
        bestScore = score;
        best = card;
      }
    });

    cards.forEach(function (card) {
      card.classList.remove('is-carousel-active');
    });
    if (best) best.classList.add('is-carousel-active');
  }

  function scheduleByobHighlight() {
    if (highlightRaf) return;
    highlightRaf = window.requestAnimationFrame(function () {
      highlightRaf = 0;
      syncByobCardHighlight();
    });
  }

  function bindByobHighlight() {
    if (!document.querySelector('#gbbBundle')) return;
    if (!highlightBound) {
      highlightBound = true;
      window.addEventListener('scroll', scheduleByobHighlight, { passive: true });
      window.addEventListener('resize', scheduleByobHighlight);
    }
    scheduleByobHighlight();
  }

  function sync() {
    var root = document.querySelector('#gbbBundle');
    if (!root) return;
    root.classList.add('rb-product-cards');
    root.querySelectorAll('.gbbProductItem').forEach(decorate);
    bindByobHighlight();
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 120);
  }

  sync();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  }
  window.addEventListener('load', sync);
  window.addEventListener('resize', schedule);

  if (window.MutationObserver) {
    var mo = new MutationObserver(schedule);
    function observe() {
      var root = document.querySelector('#gbbBundle');
      if (!root) return false;
      mo.observe(root, { childList: true, subtree: true });
      return true;
    }
    if (!observe()) {
      var boot = new MutationObserver(function () {
        if (observe()) boot.disconnect();
      });
      boot.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  /* rb-byob-mob-pills-persist-v1 — keep re-attaching if GBB wipes card internals */
  window.setInterval(sync, 1500);
})();
